import type { PadStart } from './types/pad-start.type';

/**
 * Pads the start of a string with a specified pad string until the resulting string reaches the given length.
 *
 * @typeParam TString - The type of the input string.
 * @typeParam TTimes - The target length of the resulting string. Defaults to 0.
 * @typeParam TPad - The string to pad the input with. Defaults to a single space.
 *
 * @param value - The string to pad.
 * @param length - The target length of the resulting string. If the value's length is already greater than or
 * equal to this, no padding is applied.
 * @param pad - The string to pad the input with. If not provided, a single space is used.
 * @returns The padded string, typed as `PadStart<TString, TTimes, TPad>`.
 */
export const padStart = <TString extends string, TTimes extends number = 0, TPad extends string = ' '>(
  value: TString,
  length: TTimes = 0 as TTimes,
  pad: TPad = ' ' as TPad
) => {
  return value.padStart(length, pad) as PadStart<TString, TTimes, TPad>;
};
